import { Component, Input, OnInit } from '@angular/core';
import { AppConsts } from '../../app-consts';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input('customFooter') customFooter: boolean;
  constructor() { }

  ngOnInit() {
  }

  goToMC() {
    var url = '';
    if (sessionStorage.getItem(AppConsts.Session_Lang) == 'en') {
      url = 'https://mci.gov.sa/en/pages/default.aspx';
    }
    else {
      url = 'https://mci.gov.sa/ar/pages/default.aspx';
    }
    window.open(url, '_blank');
  }

  goToThiqah() {
    var url = '';
    if (sessionStorage.getItem(AppConsts.Session_Lang) == 'en') {
      url = 'https://thiqah.sa/en/';
    }
    else {
      url = 'https://thiqah.sa/index.html';
    }
    window.open(url, '_blank');
  }

}
